import { pgTable, uuid, text, timestamp, integer, boolean, jsonb, date, pgEnum } from "drizzle-orm/pg-core";
import { sites, pages } from "./sites";
import { goals } from "./goals";

export const experimentKindEnum = pgEnum("experiment_kind", ["rewrite", "redirect"]);
export const experimentStatusEnum = pgEnum("experiment_status", ["draft", "running", "paused", "finished"]);

export const experiments = pgTable("experiments", {
  id: uuid("id").primaryKey().defaultRandom(),
  siteId: uuid("site_id").notNull().references(() => sites.id, { onDelete: "cascade" }),
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  kind: experimentKindEnum("kind").notNull(),
  status: experimentStatusEnum("status").notNull().default("draft"),
  trafficPct: integer("traffic_pct").notNull().default(100),
  targeting: jsonb("targeting").notNull().default({}),
  startedAt: timestamp("started_at", { withTimezone: true }),
  endedAt: timestamp("ended_at", { withTimezone: true }),
});

export const variants = pgTable("variants", {
  id: uuid("id").primaryKey().defaultRandom(),
  experimentId: uuid("experiment_id").notNull().references(() => experiments.id, { onDelete: "cascade" }),
  name: text("name").notNull(),
  weight: integer("weight").notNull(),
  changes: jsonb("changes").notNull().default([]),
  redirectUrl: text("redirect_url"),
});

export const experimentGoals = pgTable("experiment_goals", {
  experimentId: uuid("experiment_id").notNull().references(() => experiments.id, { onDelete: "cascade" }),
  goalId: uuid("goal_id").notNull().references(() => goals.id, { onDelete: "cascade" }),
  isPrimary: boolean("is_primary").notNull().default(false),
});

export const aggExperimentDaily = pgTable("agg_experiment_daily", {
  experimentId: uuid("experiment_id").notNull().references(() => experiments.id, { onDelete: "cascade" }),
  variantId: uuid("variant_id").notNull().references(() => variants.id, { onDelete: "cascade" }),
  goalId: uuid("goal_id").notNull().references(() => goals.id, { onDelete: "cascade" }),
  date: date("date").notNull(),
  sessions: integer("sessions").notNull().default(0),
  conversions: integer("conversions").notNull().default(0),
});
